import { render } from "./LoginSupport.vue?vue&type=template&id=3db2189a&scoped=true"
import script from "./LoginSupport.vue?vue&type=script&lang=js"
export * from "./LoginSupport.vue?vue&type=script&lang=js"

import "./LoginSupport.vue?vue&type=style&index=0&id=3db2189a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db2189a"]])

export default __exports__